















import Vue from 'vue';
import { mapState } from 'vuex';
import { DEFAULT_FEED_ROUTE } from '~/components/partials/war-room/constants';
import UserMenuMobileMainMenu from '~/components/global/UserMenuMobile/UserMenuMobileMainMenu/UserMenuMobileMainMenu.vue';
import UserMenuMobileSubMenu from '~/components/global/UserMenuMobile/UserMenuMobileSubMenu/UserMenuMobileSubMenu.vue';
import WarRoomPostButton from '~/components/partials/war-room/WarRoomPostButton.vue';
import clickOutside from '~/directives/click_outside';

interface IData {
  isSubmenuOpened: boolean;
}

export default Vue.extend({
  name: 'UserMenuMobile',
  components: {
    UserMenuMobileMainMenu,
    UserMenuMobileSubMenu,
    WarRoomPostButton,
  },
  directives: {
    'click-outside': clickOutside,
  },
  data(): IData {
    return {
      isSubmenuOpened: false,
    };
  },
  computed: {
    ...mapState('ui', ['isNotificationsDropdownOpen']),
    submenuClass(): Record<string, boolean> {
      return {
        'user-menu-mobile__submenu': true,
        'user-menu-mobile__submenu--opened': this.isSubmenuOpened,
      };
    },
    quickCreateVisible(): boolean {
      if (this.isNotificationsDropdownOpen) return false;
      if (!this.$auth.loggedIn) return false;
      return this.$route.name === DEFAULT_FEED_ROUTE;
    },
  },
  methods: {
    handleOutside() {
      if (this.isSubmenuOpened) {
        requestAnimationFrame(() => {
          this.closeSubmenu();
        });
      }
    },
    openSubmenu() {
      this.isSubmenuOpened = true;
    },
    closeSubmenu() {
      this.isSubmenuOpened = false;
    },
  },
});
